jQuery(document).ready(function ($) {

  //Tables
  $('.page-content').responsiveTables();

});